import { useMutation } from "react-query";
import { publicAxios, secureAxios } from "../../constant/auth";
import { queryClient } from "../query";
import axios from "axios";
import { ApiEndPoint } from "../../constant/api-types";

export const useCreateItem = (
  collection,
  extra_invalidate = null,
  isInvalidate = true
) => {
  return useMutation(
    (newItem) => {
      return secureAxios.post(`${collection}`, newItem).then((res) => res);
    },
    {
      onSuccess: () => {
        if (isInvalidate) {
          queryClient.invalidateQueries([collection]);
        }

        if (extra_invalidate) {
          queryClient.invalidateQueries([extra_invalidate]);
        }
      },
    }
  );
};

//to post,delete image in reacords
export const useCreateImageItem = (collection, extra_invalidate = null) => {
  let query = `${collection}`;

  return useMutation(
    (newItem) => {
      return secureAxios
        .post(`/${query}`, newItem.formdata, {
          headers: { "Content-Type": "multipart/form-data" },
        }) //{ headers:{"Content-Type": "multipart/form-data"} }
        .then((res) => {
          //(res.data.id);
          return secureAxios
            .patch(`/${query}/${res.data.id}`, {
              user_details: newItem.id,
              image_description: newItem.image_description,
              type_of_file: newItem.type_of_file,
            })
            .then((res) => {
              return res.data;
            });
        });
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["items", collection]);
        if (extra_invalidate) {
          queryClient.invalidateQueries(["items", extra_invalidate]);
        }
      },
    }
  );
};
export const useDeleteImgItem = (collection, extra_invalidate = null) => {
  let query = `${collection}`;

  return useMutation(
    (newItem) => {
      return secureAxios.delete(`/${query}/${newItem}`).then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["items", collection]);
        if (extra_invalidate) {
          queryClient.invalidateQueries(["items", extra_invalidate]);
        }
      },
    }
  );
};
//end to post image in records

export const useUpdateItem = (collection, extra_invalidate = null) => {
  let query = collection;
  // if (collection === ApiEndPoint.USERS) {
  //   query = `${collection}`;
  // } else {
  //   query = `items/${collection}`;
  // }

  return useMutation(
    // (updatedItem) => {
    //   return secureAxios
    //     .patch(`/${query}/${updatedItem.id}`, updatedItem.data)
    //     .then((res) => res.data);
    // },
    (updatedItem) => {
      return secureAxios
        .patch(`/${query}`, updatedItem.data)
        .then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        if (extra_invalidate) {
          queryClient.invalidateQueries([extra_invalidate]);
        }
        // queryClient.invalidateQueries(["user_data"]);

        queryClient.invalidateQueries([collection]);
      },
    }
  );
};

export const useSecureUpdateItem = (collection, extra_invalidate = null) => {
  let query;
  if (collection === ApiEndPoint.USERS) {
    query = collection;
  } else {
    query = `${collection}`;
  }

  return useMutation(
    (updatedItem) => {
      return secureAxios
        .patch(`/${query}`, updatedItem.data)
        .then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        if (extra_invalidate) {
          queryClient.invalidateQueries([extra_invalidate]);
        }

        queryClient.invalidateQueries([collection]);
        // queryClient.invalidateQueries(["clinics/"]);
      },
    }
  );
};

export const useDataUpdate = (collection, extra_invalidate = null) => {
  let query;
  if (collection === ApiEndPoint.USERS) {
    query = collection;
  } else {
    query = `items/${collection}`;
  }

  return useMutation(
    (updatedItem) => {
      //("update item", updatedItem);
      return secureAxios
        .patch(`/${query}`, updatedItem)
        .then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        if (extra_invalidate) {
          queryClient.invalidateQueries(["items", extra_invalidate]);
        }

        queryClient.invalidateQueries(["items", collection]);
        // queryClient.invalidateQueries(["users", collection]);
      },
    }
  );
};

export const useSecureDeleteItem = (collection) => {
  return useMutation(
    (deleteData) => {
      return secureAxios
        .delete(`${collection}`, { data: deleteData })
        .then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries([collection]);
      },
    }
  );
};

export const useDeleteItem = (collection) => {
  // let query = `items/${collection}/`;

  let query = `${collection}`;

  return useMutation(
    (data) => {
      // return secureAxios.delete(`/${query}${id}`).then((res) => res.data);
      return secureAxios.delete(`${query}`, data).then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        // queryClient.invalidateQueries(["items", collection]);

        queryClient.invalidateQueries([collection]);
      },
    }
  );
};

export const useDeleteUser = (collection) => {
  let query = `items/${collection}`;

  return useMutation(
    (id) => {
      return secureAxios.delete(`/${query}/${id}`).then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["items", collection]);
      },
    }
  );
};

export const useCreatenoticeboard = (collection) => {
  let query = `items/${collection}`;

  return useMutation(
    (newItem) => {
      // //(newItem);
      return secureAxios.post(`/${query}`, newItem).then((res) => res.data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["items", collection]);
      },
    }
  );
};

// change password

export const useChangepassword = (collection) => {
  // //(collection);
  let query = `/${collection}`;

  return useMutation(
    (newItem) => {
      // //(newItem);
      return publicAxios.post(`${query}/`, newItem).then((res) => res.data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["items", collection]);
      },
    }
  );
};

export const useUpdateUsers = (collection) => {
  // //(collection);
  let query = `/${collection}`;

  return useMutation(
    (newItem) => {
      // //(newItem);
      return secureAxios
        .patch(`${query}/${newItem.id}`, newItem.data)
        .then((res) => res.data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["users"]);
      },
    }
  );
};

export const useCreateOTP = (collection) => {
  let query = `${collection}`;

  return useMutation(
    (newItem) => {
      // //(newItem);
      return secureAxios.post(`/${query}/`, newItem).then((res) => res.data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["items", collection]);
      },
    }
  );
};

export const useVerifyOTP = (collection) => {
  let query = `${collection}`;

  return useMutation(
    (newItem) => {
      // //(newItem);
      return axios
        .post(`https://api.bharathealpoint.com/${query}`, newItem)
        .then((res) => res);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["items", collection]);
      },
    }
  );
};
